export const typography = {
    // DESIGN SYSTEM TYPOGRAPHY
    h1: {
        bold: true,
        font: 'montserrat',
        fontSize: 80,
    },
    h2: {
        bold: true,
        font: 'montserrat',
        fontSize: 60,
    },
    h3: {
        bold: true,
        font: 'montserrat',
        fontSize: 48,
    },
    h4: {
        bold: true,
        font: 'montserrat',
        fontSize: 22,
    },
    h5: {
        bold: true,
        font: 'montserrat',
        fontSize: 16,
    },
    h6: {
        bold: true,
        font: 'montserrat',
        fontSize: 12,
    },
    subtitle1: {
        font: 'montserrat',
        fontSize: 14,
    },
    subtitle2: {
        font: 'montserrat',
        fontSize: 10,
    },
    subtitle3: {
        font: 'montserrat',
        fontSize: 8,
    },
    body1: {
        font: 'openSans',
        fontSize: 16,
    },
    body2: {
        font: 'openSans',
        fontSize: 14,
        lineHeight: 20,
    },
    body3: {
        font: 'openSans',
        fontSize: 12,
    },
    caption1: {
        font: 'openSans',
        italic: true,
        fontSize: 10,
    },
    button1: {
        font: 'montserrat',
        fontSize: 15,
        bold: true,
    },
    button2: {
        font: 'montserrat',
        fontSize: 14,
        bold: true,
    },
    tooltip: {
        font: 'openSans',
        fontSize: 14,
        lineHeight: 20,
    },
    tooltipTitle: {
        font: 'montserrat',
        bold: true,
        fontSize: 14,
    },
    activeDate: {
        font: 'montserrat',
        fontSize: 20,
        bold: true,
    },
    calendarDate: {
        font: 'montserrat',
        fontSize: 17,
        bold: true,
    },
    blankField: {
        font: 'openSans',
        fontSize: 14,
        lineHeight: 16,
    },
    hourLabel: {
        font: 'montserrat',
        fontSize: 13,
        bold: true,
    },
    minuteLabel: {
        font: 'montserrat',
        fontSize: 11,
    },
    alert: {
        font: 'openSans',
        bold: true,
        fontSize: 13,
        lineHeight: 19,
    },
    notifs: {
        font: 'openSans',
        fontSize: 13,
        lineHeight: 19,
    },
    notifsBold: {
        font: 'openSans',
        bold: true,
        fontSize: 13,
        lineHeight: 19,
    },
    activeDay: {
        font: 'montserrat',
        bold: true,
        fontSize: 12,
    },
    nameTag: {
        font: 'openSans',
        bold: true,
        align: 'center',
        fontSize: 12,
        lineHeight: 17,
    },

    // CUSTOM LEGACY TYPOGRAPHY
    // TODO: DELETE THIS AND CHANGE ACROSS APP
    mainButton: {
        font: 'montserrat',
        bold: true,
        fontSize: 22,
    },
    button3: {
        font: 'openSans',
        bold: true,
        fontSize: 12,
    },
    monthLabel: {
        bold: true,
        font: 'montserrat',
        fontSize: 14,
    },
    labelDay: {
        bold: true,
        font: 'montserrat',
        fontSize: 11,
    },
    timelinerSmall: {
        font: 'montserrat',
        align: 'center',
        fontSize: 11,
        height: 14,
        color: 'timelinerGrey',
    },
    timelinerBig: {
        font: 'montserrat',
        align: 'center',
        fontSize: 13,
        height: 16,
        color: 'icon1',
    },
    weekCtrlDay: {
        bold: true,
        font: 'montserrat',
        capitalize: true,
        fontSize: 12,
    },
    weekCtrlNum: {
        font: 'montserrat',
        fontSize: 20,
        bold: true,
    },
    dayViewSelector: {
        font: 'montserrat',
        fontSize: 11,
        bold: true,
        color: 'disabled',
    },
    dayViewSelectorActive: {
        font: 'montserrat',
        fontSize: 11,
        bold: true,
    },
} as const;
